import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  changeUserPw,
  closePwChangePopup,
  findUserID,
  getIntroConfig,
  onLoginConnect,
  onLoginWEdi,
  resetPassword,
  onLoginAPIGateway,
  registerApiUser,
  resetTwoFactorAuth,
  requestOtp,
  resolveTwoFactorAuth,
  checkTwoFactAuthExpiration
} from "../AuthReducer";
import IntroLayout from "../../components/templetes/introLayout";
import { useDispatch, useSelector } from "react-redux";
import LoginForm from "../../components/organisms/loginForm";
import { TabArea } from "../../components/molecules/tab";
import PopupLayout from "../../components/templetes/popupLayout";
import { StyledButtonArea } from "../../components/molecules/buttonArea";
import { StyledButton } from "../../components/atoms/button";
import { ValidationInput } from "../../components/atoms/validation/ValidationInput";
import Validation from "../../components/atoms/validation/Validation";
import TwoFactorAuthPopup from "../component/TwoFactorAuthPopup";

const CONNECT_USER_TYPE = "connect";
const WEDI_USER_TYPE = "wedi";
const APIGW = "apigw"
const IntroContainer = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { introConfig, userId, pwChangePopupFlag, twoFactorAuth } = useSelector(
    (state) => state.auth
  );
  const [tabMode, setTabMode] = useState(localStorage.getItem("tab_mode"));
  const [connectUserID, setConnectUserID] = useState(localStorage.getItem("connect_user_ID"));
  const [wediUserID, setWediUserID] = useState(localStorage.getItem("wedi_user_ID"));
  const [apiUserID, setApiUserID] = useState(localStorage.getItem("api_user_ID"));
  const [showRegisterApiGwUserPopup, setShowRegisterApiGwUserPopup] = useState(false)
  const [rememberUserId, setRememberUserId] = useState(localStorage.getItem("remember_user_ID"));

  const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      const checkIsMobile = () => {
        const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
        const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
        setIsMobile(mobile || ('ontouchstart' in window && window.innerWidth <= 1024));
      };
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile);
      return () => window.removeEventListener('resize', checkIsMobile);
    }, []);
    return isMobile;
  };

  const isMobile = useIsMobile();
  
  useEffect(() => {
    if (isMobile) {
      if (window.location.hash !== '#/m/') {
        window.location.hash = '#/m/';
      }
    }
  }, [isMobile]);

  useEffect(() => {
    dispatch(getIntroConfig());
    if (localStorage.getItem("tab_mode") == null)
      setTabMode(CONNECT_USER_TYPE)
    if (localStorage.getItem("remember_user_ID") == null || localStorage.getItem("remember_user_ID") == false) {
      setRememberUserId(false)
      setConnectUserID("");
      setWediUserID("");
      setApiUserID("");
      return;
    }
    if (localStorage.getItem("connect_user_ID") == null)
      setConnectUserID("");
    if (localStorage.getItem("wedi_user_ID") == null)
      setWediUserID("");
    if (localStorage.getItem("api_user_ID") == null)
      setApiUserID("");

  }, []);

  useEffect(() => {
    if (!introConfig) return;
    const webediEnabled = introConfig.webediEnabled !== false;
    const apigwEnabled = introConfig.apigwEnabled !== false;
    if (
      (tabMode === WEDI_USER_TYPE && !webediEnabled) ||
      (tabMode === APIGW && !apigwEnabled)
    ) {
      setTabMode(CONNECT_USER_TYPE);
      localStorage.setItem("tab_mode", CONNECT_USER_TYPE);
    }
  }, [introConfig, tabMode]);

  const tabData = (() => {
    if (!introConfig) return [];
    const webediEnabled = introConfig.webediEnabled !== false;
    const apigwEnabled = introConfig.apigwEnabled !== false;
    const tabs = [
      {
        key: CONNECT_USER_TYPE,
        name: t("tab.connect"),
        content: (
          <>
            <LoginForm
              onLogin={(req) =>
                dispatch(onLoginConnect(req, rememberUserId))
              }
              title={t("login.title.connect")}
              config={introConfig}
              findUserID={(req, cb) =>
                dispatch(findUserID(req, CONNECT_USER_TYPE, cb))
              }
              resetPassword={(req, cb) =>
                dispatch(resetPassword(req, CONNECT_USER_TYPE, cb))
              }
              changeUserPw={(req, cb) =>
                dispatch(
                  changeUserPw(
                    {
                      ...req,
                      userId: userId,
                    },
                    CONNECT_USER_TYPE,
                    cb
                  )
                )
              }
              closePwChangePopup={() => dispatch(closePwChangePopup())}
              onClickSignUp={() => window.location.replace(introConfig.introSignupUrl)}
              pwChangePopupFlag={pwChangePopupFlag}
              localStorageId={connectUserID}
              setRememberUserId={(rememberUserId) => {
                setRememberUserId(rememberUserId)
                localStorage.setItem("remember_user_ID", rememberUserId)
              }}
              rememberUserId={rememberUserId}
            />
            {
              twoFactorAuth != null &&
              <TwoFactorAuthPopup
                title={twoFactorAuth.title}
                target={twoFactorAuth.target}
                authMethod={twoFactorAuth.authMethod}
                checkExpiration={(callbackFn) => dispatch(checkTwoFactAuthExpiration(callbackFn))}
                onSubmit={(req, callbackFn) => dispatch(resolveTwoFactorAuth(req.code, callbackFn))}
                requestOtp={(callback) => dispatch(requestOtp(callback))}
                closePopup={() => dispatch(resetTwoFactorAuth())} />
            }

          </>
        ),
      },
    ];
    if (webediEnabled) {
      tabs.push({
        key: WEDI_USER_TYPE,
        name: t("tab.wedi"),
        content: (
          <>
            <LoginForm
              onLogin={(req) =>
                dispatch(onLoginWEdi(req, rememberUserId))
              }
              title={t("login.title.wedi")}
              config={introConfig}
              findUserID={(req, cb) =>
                dispatch(findUserID(req, WEDI_USER_TYPE, cb))
              }
              resetPassword={(req, cb) =>
                dispatch(resetPassword(req, WEDI_USER_TYPE, cb))
              }
              changeUserPw={(req, cb) =>
                dispatch(
                  changeUserPw(
                    {
                      ...req,
                      userId: userId,
                    },
                    WEDI_USER_TYPE,
                    cb
                  )
                )
              }
              closePwChangePopup={() => dispatch(closePwChangePopup())}
              pwChangePopupFlag={pwChangePopupFlag}
              onClickSignUp={() => window.location.replace(introConfig.introSignupUrl)}
              localStorageId={wediUserID}
              setRememberUserId={(rememberUserId) => {
                setRememberUserId(rememberUserId)
                localStorage.setItem("remember_user_ID", rememberUserId)
              }}
              rememberUserId={rememberUserId}
            />
            {
              twoFactorAuth != null &&
              <TwoFactorAuthPopup
                title={twoFactorAuth.title}
                target={twoFactorAuth.target}
                authMethod={twoFactorAuth.authMethod}
                checkExpiration={(callbackFn) => dispatch(checkTwoFactAuthExpiration(callbackFn))}
                onSubmit={(req, callbackFn) => dispatch(resolveTwoFactorAuth(req.code, callbackFn))}
                requestOtp={(callbackFn) => dispatch(requestOtp(callbackFn))}
                closePopup={() => dispatch(resetTwoFactorAuth())} />
            }
          </>
        ),
      });
    }
    if (apigwEnabled) {
      tabs.push({
        key: APIGW,
        name: t("tab.apigw"),
        content: (
          <>

            <LoginForm
              hasUserName={false}
              onLogin={(req, redirect) =>
                dispatch(onLoginAPIGateway(req, redirect, rememberUserId))
              }
              title={t("login.title.apigw")}
              config={introConfig}
              findUserID={(req, cb) =>
                dispatch(findUserID(req, APIGW, cb))
              }
              resetPassword={(req, cb) =>
                dispatch(resetPassword(req, APIGW, cb))
              }
              changeUserPw={(req, cb) =>
                dispatch(
                  changeUserPw(
                    {
                      ...req,
                      userId: userId,
                    },
                    APIGW,
                    cb
                  )
                )
              }
              closePwChangePopup={() => dispatch(closePwChangePopup())}
              pwChangePopupFlag={pwChangePopupFlag}
              onClickSignUp={() => setShowRegisterApiGwUserPopup(true)}
              localStorageId={apiUserID}
              setRememberUserId={(rememberUserId) => {
                setRememberUserId(rememberUserId)
                localStorage.setItem("remember_user_ID", rememberUserId)
              }}
              rememberUserId={rememberUserId}
            />
            {
              showRegisterApiGwUserPopup &&
              <APIGatewayUserRegisterForm
                onClosePopup={() => setShowRegisterApiGwUserPopup(false)}
                onConfirm={(user) => dispatch(registerApiUser(user, () => {
                  alert(t("apigw.register.success", { userId: user.userId }))
                  setShowRegisterApiGwUserPopup(false)
                }))}
              />
            }

          </>
        ),
      });
    }
    return tabs;
  })();

  return (
    introConfig && (
      <IntroLayout config={introConfig}>
        <TabArea
          tabData={tabData}
          setMode={(mode) => {
            setTabMode(mode)
            localStorage.setItem("tab_mode", mode)
          }}
          mode={tabMode}
        />

      </IntroLayout>
    )
  );
};
export default IntroContainer;

const APIGatewayUserRegisterForm = ({
  onConfirm = () => { },
  onClosePopup
}) => {
  const { t } = useTranslation();
  const [validation, setValidation] = useState(false)
  const [userId, setUserId] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [passwordConfirm, setPasswordConfirm] = React.useState("")
  const [email, setEmail] = React.useState("");
  return (
    <PopupLayout
      theme="primary"
      data-size="lg"
      title={t("apigw.register.title")}
      closePopup={onClosePopup}
      button={
        <StyledButtonArea>
          <StyledButton
            type="text"
            data-bg="primary"
            size="md"
            onClick={() => {
              if (userId == "" || password == "" || passwordConfirm == "") {
                setValidation(true)
                return;
              }
              onConfirm({
                userId: userId,
                password: password,
                passwordConfirm: passwordConfirm,
                email: email
              })
            }}
          >
            {t("common.confirm")}
          </StyledButton>
        </StyledButtonArea>
      }
    >
      <Validation>
        <ValidationInput
          label={t("apigw.register.userId")}
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          invalidMsg={t("apigw.register.userIdRequired")} showValidate={validation} />
        <ValidationInput label={t("apigw.register.password")} type="password" value={password}
          onChange={e => setPassword(e.target.value)}
          invalidMsg={t("apigw.register.passwordRequired")}
          showValidate={validation} />
        <ValidationInput
          label={t("apigw.register.passwordConfirm")}
          type="password"
          invalidMsg={t("apigw.register.passwordConfirmInvalid")}
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          showValidate={validation}
        />
        <ValidationInput label={t("apigw.register.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}

        />
      </Validation>
    </PopupLayout>
  )
}